<section>
  <div>
    <div class="inner-wrap">
      <p class="text-center">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany">
      </p>
      <h2>ENTER OTP</h2>
      <form autocomplete="off" [formGroup]="verifyOTPForm" (keydown.enter)="submitOTP()">
        <div class="form-group">
          
          <input id="validation-email" class="form-control" placeholder="OTP" type="text" 
            [(ngModel)]="otpCode" formControlName="otpCode" 
            (keydown)="onlyNumber($event)" minlength="4" maxlength="4" autocomplete="off">
          <div *ngIf="verifyOTPForm.controls['otpCode'].hasError('required') && verifyOTPForm.controls['otpCode'].touched"
            class="form-control-error-custom" style="text-align:left;">
            Please enter the OTP code to continue.
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
            [disabled]="!verifyOTPForm.valid || showSpinner" 
            [class.loading]="showSpinner"
            (click)="submitOTP()">
            <i aria-hidden="true"></i>Confirm OTP
          </button>
        </div>
        <div class="text-center">
          <button type="button" class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;"
            [disabled]="showSpinner"
            (click)="resendOTP()">
            <i aria-hidden="true"></i>Resend OTP
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
